<template>
  <div
    v-show="Active"
    class="my-3"
    :QuestionNo="QuestionNo"
  >
    <pre
      style="white-space:pre-line"
      class="break-word"
      v-html="description"
    />
  </div>
</template>

<script>
export default {
  props: {
    QuestionNo: Number,
    description: String,
    img: String,
    must: Boolean,
    mustAlertWording: String,
    Active: Boolean,
    formCategoryValueCnt: Number
  }
};
</script>
